import {createRoot, hydrateRoot} from 'react-dom/client';
import ShopCollection from '../pages/ShopCollection/ShopCollection'
import "../index.css";
import "../pages/ShopCollection/ShopCollection.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ShopCollection {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ShopCollection {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ShopCollectionVC = {mount, hydrate, unmount}